import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';

import { SocialAccountIcon } from 'components';

import { INetwork } from '../types';

interface IProps {
  network: INetwork;
  onConnect: () => void;
}

const Inactive: FC<IProps> = ({ network, onConnect }) => {
  const { t } = useTranslation();
  const { provider, name } = network;

  function renderConnect() {
    return (
      <Button size="small" color="primary" onClick={onConnect}>
        <strong>{t('common:connect')}</strong>
      </Button>
    );
  }

  return (
    <Grid container alignItems="center" justify="space-between">
      <Grid item>
        <Grid container>
          <Grid item>
            <SocialAccountIcon active={false} provider={provider} />
          </Grid>
          <Grid item>
            <Typography variant="subtitle2">{name}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{renderConnect()}</Grid>
    </Grid>
  );
};

export default Inactive;
